declare var require: any;
export default {
	// users
	corpUserDetails: require('./users/corpUserDetails'),
	singlePermission: require('./users/singlePermission'),
	corpUsers: require('./users/corpUsers'),
	singleCorpUser: require('./users/singleCorpUser'),
	corpUserData: require('./users/corpUserData'),
	userProfile: require('./users/userProfile'),
	users: require('./users/users'),
	singleUser: require('./users/singleUser'),
	singleImportError: require('./users/singleImportError'),
	importedUsersData: require('./users/importedUsersData'),
	singleAccountManager: require('./users/singleAccountManager'),
	accountManagers: require('./users/accountManagers'),
	notifications: require('./alertsAndNotifications/alertsAndNotifications'),
	// numbers
	numbersForUser: require('./numbers/numbersForUser'),
	singleNumber: require('./numbers/singleNumber'),
	creditLimit: require('./numbers/creditLimit'),
	usageHistory: require('./numbers/usageHistory'),
	singlePackage: require('./numbers/singlePackage'),
	billingAccountNoForNumber: require('./numbers/billingAccountNoForNumber'),
	usage: require('./numbers/usage'),
	dataUsage: require('./numbers/dataUsage'),
	dataUsages: require('./numbers/dataUsages'),
	cpnAccount: require('./numbers/cpnAccount'),
	productOrderResponse: require('./numbers/productOrderResponse'),
	bannedNumbers: require('./numbers/bannedNumbers'),
	getAccountNumberInfoByNumber: require('./numbers/getAccountNumberInfoByNumber'),
	countries: require('./numbers/countries'),
	singleDialingCode: require('./numbers/singleDialingCode'),
	dialingCodes: require('./numbers/dialingCodes'),
	singleFbbEmail: require('./numbers/singleFbbEmail'),
	getFbbEmailsResponse: require('./numbers/getFbbEmailsResponse'),
	// products
	customerProducts: require('./products/customerProducts'),
	singleProduct: require('./products/singleProduct'),
	singleCustomerProduct: require('./products/singleCustomerProduct'),
	products: require('./products/products'),
	createProductOrderResponse: require('./products/createProductOrderResponse'),
	checkResourceAvailableResponse: require('./products/checkResourceAvailableResponse'),
	simDetails: require('./products/simDetails'),
	productsDetails: require('./postpaidLines/postpaidLines'),
	// accounts
	accounts: require('./accounts/accounts'),
	singleAccount: require('./accounts/singleAccount'),
	corpAccounts: require('./accounts/corpAccounts'),
	singleCorpAccount: require('./accounts/singleCorpAccount'),
	accountDetails: require('./accounts/accountDetails'),
	singleStatistic: require('./accounts/singleStatistic'),
	statisticsForAccounts: require('./accounts/statisticsForAccounts'),
	numbersForAccount: require('./accounts/numbersForAccount'),
	numbersForBillingAccount: require('./accounts/numbersForBillingAccount'),
	singleBillingNumber: require('./accounts/singleBillingNumber'),
	billingAccountInformation: require('./accounts/billingAccountInformation'),
	customerAccountResponse: require('./accounts/customerAccountResponse'),
	availableAccountManagers: require('./accounts/availableAccountManagers'),
	admins: require('./accounts/admins'),
	managers: require('./accounts/managers'),
	updateOrganizationTaxId: require('./accounts/updateOrganizationTaxId'),
	// eCommerce
	packages: require('./ecommerce/packages'),
	// authorization
	auth: require('./authorization/auth'),
	resetPassword: require('./authorization/resetPassword'),
	// bills
	bills: require('./bills/bills'),
	unpaidBills: require('./bills/unpaidBills'),
	billPdf: require('./bills/billPdf'),
	billingIds: require('./bills/billingIds'),
	singleBillId: require('./bills/singleBillId'),
	amountPerMonth: require('./bills/amountPerMonth'),
	billsHistoryForAccount: require('./bills/billsHistoryForAccount'),
	// departments
	departments: require('./departments/departments'),
	departmentDetails: require('./departments/departmentDetails'),
	singleDepartment: require('./departments/singleDepartment'),
	// payments
	payments: require('./payments/payments'),
	singlePayment: require('./payments/singlePayment'),
	paymentDetails: require('./payments/paymentDetails'),
	paymentTokens: require('./payments/paymentTokens'),
	singleCommitmentDetails: require('./payments/singleCommitmentDetails'),
	commitmentDetails: require('./payments/commitmentDetails'),
	commitmentDetailsResponse: require('./payments/commitmentDetailsResponse'),
	// resources
	singleResource: require('./resources/singleResource'),
	resources: require('./resources/resources'),
	singleAvailableNumber: require('./resources/singleAvailableNumber'),
	availableNumbers: require('./resources/availableNumbers'),
	// charities
	singleCharity: require('./charities/singleCharity'),
	charities: require('./charities/charities'),
	// usageLogos
	singleUsageLogo: require('./usageLogos/singleUsageLogo'),
	usageLogos: require('./usageLogos/usageLogos'),
	// search
	singleSearchNumber: require('./search/singleSearchNumber'),
	singleSearchUser: require('./search/singleSearchUser'),
	singleSearchBillingAccount: require('./search/singleSearchBillingAccount'),
	searchResults: require('./search/searchResults'),
	// shortcuts
	singleOption: require('./shortcuts/singleOption'),
	// errors
	singleErrorMessage: require('./errors/singleErrorMessage'),
	errorMessages: require('./errors/errorMessages'),
	// trouble ticketing
	categories: require('./troubleTicketing/categories'),
	selectOption: require('./troubleTicketing/selectOptions'),
	singleCategory: require('./troubleTicketing/singleCategory'),
	singleSelectOption: require('./troubleTicketing/singleSelectOption'),
	incident: require('./troubleTicketing/incident'),
	interaction: require('./troubleTicketing/interaction'),
	// order tracking
	singleOrderStatus: require('./orderTracking/singleOrderStatus'),
	orderStatus: require('./orderTracking/orderStatus'),
	// subscriber products
	singleSubscriberProduct: require('./subscriberProducts/singleSubscriberProduct'),
	subscriberProducts: require('./subscriberProducts/subscriberProducts'),
	// prepaidLoyalty
	loyaltyGroup: require('./prepaidLoyalty/loyaltyGroup'),
	singleLoyaltyNumber: require('./prepaidLoyalty/singleLoyaltyNumber'),
	loyaltyGroups: require('./prepaidLoyalty/loyaltyGroups'),
	createUpdateLoyaltyResponse: require('./prepaidLoyalty/createUpdateLoyaltyResponse'),
	loyaltyGroupDetails: require('./prepaidLoyalty/loyaltyGroupDetails'),
	subscriptionDetails: require('./prepaidLoyalty/subscriptionDetails'),
	groupSubscriptions: require('./prepaidLoyalty/groupSubscriptions'),
	//topUpAddons
	subscriptions: require('./topUpAddons/subscriptions'),
	singleSubscription: require('./topUpAddons/singleSubscription'),
	//billingPayments
	offlinePayments: require('./billingPaymentTrack/offlinePayments'),
	offlinePayment: require('./billingPaymentTrack/offlinePayment'),
	offlinePaymentCreate: require('./billingPaymentTrack/offlinePaymentCreate'),
	offlinePaymentAttachment: require('./billingPaymentTrack/offlinePaymentAttachment'),
	bankItem: require('./billingPaymentTrack/bankItem'),
	bankItems: require('./billingPaymentTrack/bankItems'),
	//eshop
	productsByParentCategory: require('./eshop/products'),
	inventoryByProductId: require('./eshop/inventory'),
	productById: require('./eshop/singleProduct'),
	priceByCatEntry: require('./eshop/priceByCatEntry'),
	validateCart: require('./eshop/validateCart'),
	viewCart: require('./eshop/viewCart'),
	guestLogIn: require('./eshop/guestLogIn'),
	purchaseDeviceHistory: require('./eshop/purchaseDeviceHistory'),
	purchaseHistoryOrder: require('./eshop/purchaseHistoryOrder.ts'),
	tracking: require('./eshop/tracking.ts'),
	//vouchers
	calculateInstallment: require('./vouchers/calculateInstallment'),
	getSmartVoucher: require('./vouchers/getSmartVoucher'),
	singleVoucher: require('./vouchers/singleVoucher'),
	// remote config
	remoteConfig: require('./remoteConfig/remoteConfig'),
	// activities
	singleActivity: require('./activities/singleActivity'),
	activities: require('./activities/activities'),
	interactionDetailsResponse: require('./activities/interactionDetailsResponse'),
	// complaints
	singleTicket: require('./tickets/singleTicket'),
	tickets: require('./tickets/ticktes'),
	//requests
	singleRequest: require('./requests/singleRequest'),
	requests: require('./requests/requests'),
};
